import { authenticatedFastApiAxiosInstance } from "@/lib/data/http";
import { baseFastApiMatterRoute } from "@/lib/data/requests/matters/matter";
import {
  type APIResponse,
  type MatterLitigationDatePlanDate,
} from "@/lib/types";

export const retrieveMatterLitigationDatePlanDatesV1 = async (id?: string) => {
  return authenticatedFastApiAxiosInstance
    .get<
      APIResponse<MatterLitigationDatePlanDate[]>
    >(`${baseFastApiMatterRoute}/litigation-dates/plans/${id}`)
    .then((res) => res.data);
};

export const createMatterLitigationDatePlanDateV1 = async (
  data: Pick<
    MatterLitigationDatePlanDate,
    "deadline" | "planId" | "triggerId" | "typeId"
  >,
) => {
  return authenticatedFastApiAxiosInstance
    .post<
      APIResponse<MatterLitigationDatePlanDate>
    >(`${baseFastApiMatterRoute}/litigation-dates/plans/dates`, data)
    .then((res) => res.data);
};

export const updateMatterLitigationDatePlanDateV1 = async (
  data: Pick<MatterLitigationDatePlanDate, "dateModified" | "id" | "planId"> &
    Partial<
      Pick<MatterLitigationDatePlanDate, "deadline" | "triggerId" | "typeId">
    >,
) => {
  return authenticatedFastApiAxiosInstance
    .patch<
      APIResponse<MatterLitigationDatePlanDate>
    >(`${baseFastApiMatterRoute}/litigation-dates/plans/dates`, data)
    .then((res) => res.data);
};

export const deleteMatterLitigationDatePlanDateV1 = async (
  data: Pick<MatterLitigationDatePlanDate, "id" | "planId">,
) => {
  const { id, planId } = data;
  return authenticatedFastApiAxiosInstance
    .delete<
      APIResponse<MatterLitigationDatePlanDate>
    >(`${baseFastApiMatterRoute}/litigation-dates/plans/${planId}/dates/${id}`)
    .then((res) => res.data);
};
